import { createContext } from 'react';
import { ContextMenuBook } from 'src/app/types';

export const ContextMenuTypeContext = createContext<ContextMenuBook>(
  ContextMenuBook.DocumentFolder,
);
